import { EXERCISE_KEY } from '../../constants'
import { MEDIA_LAYOUT_TYPE, MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX } from '../../../../images/constants'
import { getIdReduxUtil } from '../../../../redux/utils/get-id'
import { getValueReduxUtil } from '../../../../redux/utils/get-value'

function getImageUriExerciseUtil (exercise, layoutType) {
  if (!exercise) {
    return
  }
  const image = getValueReduxUtil(exercise, EXERCISE_KEY.IMAGE)
  if (!image) {
    return
  }
  const imageSuffix = (
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[layoutType] ||
    MEDIA_LAYOUT_TYPE_TO_FILE_SUFFIX[MEDIA_LAYOUT_TYPE.ROW]
  )
  const id = getIdReduxUtil(exercise)
  return `exercise/${id}/${image.replace('.', `-${imageSuffix}.`)}`
}

export default getImageUriExerciseUtil
